import apiClient from './axios';
let pending = null;
export function refreshBilling() {
  if (!pending) pending = apiClient.post('/api/billing/reconcile').then(({ data }) => {
    window.dispatchEvent(new CustomEvent('billing-updated', { detail: data }));
    return data;
  }).finally(() => { pending = null; });
  return pending;
}
